export const pddFormTranslations = {
    es: {
        title: 'Cuestionario de Privacidad',
        activities: {
            '300000004355456_literal': 'ACADEMIA DE IDIOMAS',
            '300000004365466_literal': 'ACTIVIDADES AUDIOVISUALES Y/O DE FOTOGRAFÍA',
            '300000004355487_literal': 'ACTIVIDADES DE CAMBIO DE MONEDA ',
            '300000004365502_literal': 'ACTIVIDADES DE CONSULTORÍA',
            '300000004365504_literal': 'ACTIVIDADES DE DEPÓSITO, CUSTODIA O TRANSPORTE PROFESIONAL DE FONDOS O MEDIOS DE PAGO ',
            '300000004364404_literal': 'ACTIVIDADES EXTRAESCOLARES',
            '300000004365471_literal': 'ACTIVIDADES INMOBILIARIAS',
            '300000004355457_literal': 'ACTIVIDADES LÚDICAS',
            '300000004364398_literal': 'ACTIVIDADES SANITARIAS',
            '300000004365472_literal': 'ADMINISTRACIÓN DE LOTERÍA',
            '300000004355458_literal': 'ADMINISTRADOR DE FINCAS',
            '300000004364405_literal': 'AGENCIA DE ARTISTAS',
            '300000004365473_literal': 'AGENCIA DE VIAJES',
            '300000004355459_literal': 'AGENTE DE SEGUROS',
            '300000004365474_literal': 'ALQUILER DE VEHÍCULOS',
            '300000397986626_literal': 'ARTES GRÁFICAS',
            '300000004355460_literal': 'ASESORAMIENTO FISCAL Y LABORAL',
            '300000004364407_literal': 'ASESORAMIENTO FISCAL, LABORAL Y AAFF',
            '300000004365475_literal': 'ASESORAMIENTO FISCAL, LABORAL Y AGENTE DE SEGUROS',
            '300000004355461_literal': 'ASESORAMIENTO FISCAL, LABORAL, AAFF Y AGENTE DE SEGUROS',
            '300000397986664_literal': 'ASESORAMIENTO FISCAL, LABORAL, JURÍDICO, AAFF, INMOBILIARIA Y AGENTE DE SEGUROS',
            '300000004364408_literal': 'ASESORAMIENTO JURÍDICO, FISCAL Y LABORAL',
            '300000004365476_literal': 'ASESORAMIENTO JURÍDICO, FISCAL, LABORAL Y AAFF',
            '300000004355462_literal': 'ASESORIA FISCAL- CONTABLE',
            '300000004364409_literal': 'ASESORIA JURÍDICA',
            '300000004365477_literal': 'ASESORIA LABORAL',
            '300000004355463_literal': 'ASOCIACIÓN',
            '300000004364402_literal': 'ASOCIACIÓN SIN ÁNIMO DE LUCRO',
            '300000004365478_literal': 'AUTOESCUELA',
            '300000004365465_literal': 'CASINO DE JUEGOS',
            '300000004364411_literal': 'CENTRO DE ESTETICA',
            '300000004365479_literal': 'CENTRO DE FORMACIÓN',
            '300000004355465_literal': 'CENTRO DE LA TERCERA EDAD',
            '300000397906187_literal': 'CENTRO DE TATUAJES',
            '300000004364412_literal': 'CENTRO EDUCATIVO',
            '300000004365480_literal': 'CENTRO MÉDICO - ESPECIALIDADES',
            '300000004355466_literal': 'CLÍNICA DENTAL',
            '300000004364413_literal': 'CLÍNICA VETERINARIA',
            '300000004365481_literal': 'CLOUD COMPUTING',
            '300000004355467_literal': 'CLUB DEPORTIVO',
            '300000004364414_literal': 'COFRADIA',
            '300000398014086_literal': 'COFRADIA DE PESCADORES',
            '300000004365482_literal': 'COLEGIO PROFESIONAL',
            '300000004364403_literal': 'COMERCIALIZACIÓN DE BIENES',
            '300000004364401_literal': 'COMERCIALIZACIÓN DE OBRAS DE ARTE O ANTIGUEDADES',
            '300000004365505_literal': 'COMERCIALIZADORA',
            '300000004365483_literal': 'COMERCIO',
            '300000004364415_literal': 'COMUNIDAD DE PROPIETARIOS',
            '300000004355468_literal': 'COMUNIDAD DE REGANTES',
            '300000004365484_literal': 'CONCESIONARIO',
            '300000397943090_literal': 'CONGREGACIÓN',
            '300000397905752_literal': 'CONSORCIO',
            '300000004355489_literal': 'CONSTRUCCIÓN Y OTRAS ACTIVIDADES PROFESIONALES RELACIONADAS',
            '300000004355469_literal': 'CONSULTORA RRHH',
            '300000004364416_literal': 'COOPERATIVA',
            '300000004365485_literal': 'CORREDURIA DE SEGUROS',
            '300000004355470_literal': 'DETECTIVE/INVESTIGADOR',
            '300000004364435_literal': 'DISTRIBUIDORA (agua, luz, gas)',
            '300000004364417_literal': 'EDITORIAL',
            '300000004365486_literal': 'EMPRESA DE DESTRUCCIÓN DE DOCUMENTACIÓN Y DISPOSITIVOS ELECTRONICOS',
            '300000004364433_literal': 'EMPRESA DE ESTUDIOS DE MERCADO',
            '300000004355471_literal': 'EMPRESA DE SEGURIDAD',
            '300000004364418_literal': 'EMPRESA ETT',
            '300000398050770_literal': 'ENTIDAD ASEGURADORA Y REASEGURADORA',
            '300000004365467_literal': 'ENTIDAD DE CRÉDITO',
            '300000004355453_literal': 'ENTIDAD DE PAGO Y DE DINERO ELECTRÓNICO',
            '300000004365487_literal': 'ENTIDAD DE RECOBRO',
            '300000004355472_literal': 'FARMACIA',
            '300000004364419_literal': 'FEDERACIÓN',
            '300000004365488_literal': 'FUNDACIÓN',
            '300000004355455_literal': 'GESTIÓN PATRIMONIAL Y/O DE ORGANIZACIONES',
            '300000004364400_literal': 'GESTORES DE SISTEMAS DE PAGO Y GESTORES DE TARJETAS DE CRÉDITO',
            '300000004355473_literal': 'GIMNASIO',
            '300000004364420_literal': 'GUARDERIA',
            '300000004365489_literal': 'HOSPITAL - CLÍNICA',
            '300000004355474_literal': 'HOSTELERÍA',
            '300000397906573_literal': 'IMPRENTA',
            '300000004364399_literal': 'INDUSTRIA Y ACTIVIDADES RELACIONADAS',
            '300000004364421_literal': 'INMOBILIARIA Y AAFF',
            '300000004365490_literal': 'INMOBILIARIA Y AGENTE DE SEGUROS',
            '300000004355475_literal': 'INMOBILIARIA, AAFF Y AGENTE DE SEGUROS',
            '300000004365470_literal': 'INTERMEDIACIÓN EN LA CONCESIÓN DE PRÉSTAMOS O CRÉDITOS',
            '300000004365468_literal': 'JOYERIA',
            '300000004364422_literal': 'LABORATORIO',
            '300000398103888_literal': 'MANCOMUNIDAD',
            '300000004365491_literal': 'MANTENIMIENTO HARDWARE',
            '300000004355476_literal': 'MANTENIMIENTO HARDWARE Y SOFTWARE',
            '300000004364423_literal': 'MANTENIMIENTO HARDWARE, SOFTWARE Y SERVICIOS WEB',
            '300000004365492_literal': 'MANTENIMIENTO HARDWARE, SOFTWARE, SERVICIOS WEB Y BACKUP',
            '300000004355477_literal': 'MANTENIMIENTO HARDWARE, SOFTWARE, SERVICIOS WEB, BACKUP Y HOSTING',
            '300000004364424_literal': 'MANTENIMIENTO SOFTWARE',
            '300000004365493_literal': 'MEDIO DE COMUNICACIÓN',
            '300000004355478_literal': 'NOTARÍA',
            '300000004364425_literal': 'ÓPTICA',
            '300000004365494_literal': 'ORGANIZADOR DE EVENTOS',
            '300000004364426_literal': 'PARROQUIA',
            '300000004365495_literal': 'PARTIDO POLITICO',
            '300000397943074_literal': 'PELUQUERÍA ',
            '300000397867348_literal': 'PERSONAL TRAINER',
            '300000004355454_literal': 'PERSONAS FÍSICAS QUE REALICEN MOVIMIENTOS DE MEDIOS DE PAGO',
            '300000004364434_literal': 'PERSONAS QUE EJERZAN LAS ACTIVIDADES DE LA LEY 43/2007',
            '300000004364427_literal': 'PESQUERA',
            '300000004365506_literal': 'PRESTADOR DE SERVICIOS DE INVERSIÓN',
            '300000004365496_literal': 'PROCURADURÍA',
            '300000004355452_literal': 'PROPIEDAD NO HORIZONTAL',
            '300000004355481_literal': 'RESIDENCIA O GERIÁTRICO',
            '300000398051375_literal': 'SALÓN DE JUEGOS',
            '300000004364428_literal': 'SELECCIÓN PERSONAL',
            '300000004365497_literal': 'SERVICIOS BACKUP',
            '300000004355482_literal': 'SERVICIOS COMMUNITY MANAGER',
            '300000004364397_literal': 'SERVICIOS DE AGRICULTURA, GANADERÍA Y PESCA',
            '300000004364406_literal': 'SERVICIOS DE ALOJAMIENTO',
            '300000397410020_literal': 'SERVICIOS DE ARQUITECTURA',
            '300000004364410_literal': 'SERVICIOS DE AUDITORIA',
            '300000004364429_literal': 'SERVICIOS DE BACKUP Y HOSTING',
            '300000004365498_literal': 'SERVICIOS DE CATERING',
            '300000397410243_literal': 'SERVICIOS DE INGENIERIA ',
            '300000004355483_literal': 'SERVICIOS DE LIMPIEZA',
            '300000004364430_literal': 'SERVICIOS DE MANTENIMIENTO',
            '300000004355480_literal': 'SERVICIOS DE PERITAJE',
            '300000004365464_literal': 'SERVICIOS DE TELECOMUNICACIONES',
            '300000398050789_literal': 'SERVICIOS DE TRADUCCIÓN E INTERPRETACIÓN',
            '300000004365499_literal': 'SERVICIOS FUNERARIOS',
            '300000004355484_literal': 'SERVICIOS HOSTING',
            '300000004364431_literal': 'SERVICIOS MARKETING Y PUBLICIDAD',
            '300000004365469_literal': 'SERVICIOS POSTALES DE ACTIVIDADES DE GIRO O TRANSFERENCIA',
            '300000004365500_literal': 'SERVICIOS WEB',
            '300000004355485_literal': 'SINDICATO',
            '300000004365503_literal': 'SOCIEDAD DE GARANTÍA RECÍPROCA',
            '300000004355488_literal': 'SOCIEDAD GESTORA DE ENTIDADES DE CAPITAL-RIESGO',
            '300000004364432_literal': 'TALLER',
            '300000004365501_literal': 'TRANSPORTE PASAJEROS',
            '300000004355486_literal': 'TRANSPORTE Y LOGISTICA',
        },
        sections: {
            privacy_management: {
                name: 'Gestión de la privacidad',
                description: 'Gestión de la privacidad',
                validations: '',
                context: '',
            },
            risk_management: {
                name: 'Gestión de riesgos',
                description: '',
                validations: '',
                context: '',
            },
            personal_management: {
                name: 'Gestión del personal',
                description: '',
                validations: '',
                context: '',
            },
            thirdpartyvendor_management: {
                name: 'Gestión de proveedores',
                description: '',
                validations: '',
                context: '',
            },
            validation_management: {
                name: 'Validación',
                description: '',
                validations: '',
                context: '',
            },
            eipd_management: {
                name: 'Evaluación impacto',
                description: '',
                validations: '',
                context: '',
            },
            documentation_management: {
                name: 'Documentación',
                description: '',
                validations: '',
                context: '',
            },
        },
        questions: {
            marketing_channels: {
                question: '¿Qué medios utilizáis para las comunicaciones publicitarias?',
                helpText: 'Seleccione todos los medios que utiliza para enviar comunicaciones comerciales',
                validations: '',
                context: '',
            },
            video_surveillance: {
                question: '¿Captáis imágenes mediante un sistema de videovigilancia?',
                helpText: 'Indique si dispone de cámaras de seguridad que capten imágenes de personas',
                validations: '',
                context: '',
            },
            capture_images: {
                question: '¿El sistema graba las imágenes captadas?',
                helpText: 'Indique si graban las imágenes captadas',
                validations: '',
                context: '',
            },
            data_processing_types: {
                question: '¿Tratáis alguno de estos datos?',
                helpText: 'Seleccione todos los tipos de tratamientos de datos que aplican en su organización',
                validations: '',
                context: '',
            },
            real_estate_sales: {
                question: '¿Realizáis compraventa de bienes inmuebles?',
                helpText: 'Indique si la empresa compra o vende bienes inmuebles',
                validations: '',
                context: '',
            },
            request_solvency: {
                question: '¿En la gestión de hipotecas solicitáis informes de solvencia patrimonial?',
                helpText: 'Indique si, al gestionar hipotecas, se solicita información sobre la solvencia del solicitante',
                validations: '',
                context: '',
            },
            real_estate_rental: {
                question: '¿Realizáis alquileres de bienes inmuebles?',
                helpText: 'Indique si la empresa alquila propiedades como parte de su actividad',
                validations: '',
                context: '',
            },
            high_rent_check: {
                question: '¿Las rentas de los alquileres son iguales o superiores a los 120.000€ anuales o a los 10.000€ mensuales?',
                helpText: 'Seleccione si las rentas de los alquileres cumplen o superan dichos importes',
                validations: '',
                context: '',
            },
            financial_operations: {
                question: '¿La empresa participa o actúa por cuenta de clientes en operaciones financieras o inmobiliarias?',
                helpText: 'Indique si actúa en nombre de clientes en operaciones financieras o de bienes inmuebles',
                validations: '',
                context: '',
            },
            certified_courses: {
                question: '¿Ofrecéis enseñanzas y/o cursos homologados?',
                helpText: 'Indique si imparten formación reglada u homologada por organismos oficiales',
                validations: '',
                context: '',
            },
            donations: {
                question: '¿La empresa recibe donaciones?',
                helpText: 'Indique si su organización recibe contribuciones económicas o materiales de terceros',
                validations: '',
                context: '',
            },
            driving_courses: {
                question: '¿Realizáis cursos de recuperación de puntos y/o certificación de aptitud profesional (CAP)?',
                helpText: 'Indique si ofrecen formación vial relacionada con CAP o recuperación de puntos del carnet de conducir',
                validations: '',
                context: '',
            },
            canteen_service: {
                question: '¿Tenéis servicio de comedor?',
                helpText: 'Indique si dispone de servicio de comedor para el personal',
                validations: '',
                context: '',
            },
            orientation_services: {
                question: '¿Ofrecéis servicios de orientación y pedagógicos?',
                helpText: 'Indique si su entidad proporciona apoyo pedagógico o de orientación',
                validations: '',
                context: '',
            },
            life_insurance: {
                question: '¿Operáis con seguros relacionados en el ramo de vida o con inversiones?',
                helpText: 'Seleccione si su empresa intermedia seguros de vida o productos financieros',
                validations: '',
                context: '',
            },
            job_board: {
                question: '¿Disponéis de bolsa de trabajo?',
                helpText: 'Indique si su organización gestiona o dispone de una bolsa de empleo',
                validations: '',
                context: '',
            },
            training_services: {
                question: '¿Ofrecéis servicios de formación y/o ponencias a los colegiados?',
                helpText: 'Indique si se ofrecen charlas, ponencias o cursos a colegiados',
                validations: '',
                context: '',
            },
            clinical_lab_services: {
                question: '¿Prestáis servicios como laboratorio clínico y/o genético?',
                helpText: 'Seleccione si su organización actúa como laboratorio médico o genético',
                validations: '',
                context: '',
            },
            anonymized_data: {
                question: '¿En todos los casos recibís los datos de forma anonimizada?',
                helpText: 'Indique si los datos que recibe su organización están anonimizados en todos los casos',
                validations: '',
                context: '',
            },
            test_psicotecnicos: {
                question: '¿El servicio de selección de personal incluye la realización de tests psicotécnicos a las personas candidatas?',
                helpText: '',
                validations: '',
                context: '',
            },
            alarma_remoto: {
                question: '¿Si ofrecéis el servicio de videovigilancia y/o alarmas, tenéis acceso remoto a las imágenes captadas?',
                helpText: '',
                validations: '',
                context: '',
            },
            estudio_mercado: {
                question: '¿Para realizar el estudio de mercado es necesario recabar datos personales de las personas que participan?',
                helpText: '',
                validations: '',
                context: '',
            },
            federdep: {
                question: '¿Sois una federación deportiva?',
                helpText: '',
                validations: '',
                context: '',
            },
            deudaaquiere: {
                question: '¿Adquirís la deuda de vuestros clientes?',
                helpText: '',
                validations: '',
                context: '',
            },
            dispone_rp: {
                question: '¿Existe una persona responsable de la privacidad de datos en la empresa?',
                helpText: '',
                validations: '',
                context: '',
            },
            rp_datos: {
                question: 'Debes disponer de esta figura. Indícanos el nombre y los apellidos de la persona que ejerce o que va a ejercer como responsable de privacidad',
                helpText: '',
                validations: '',
                context: '',
            },
            dpd_info: {
                question: '¿Tenéis un delegado de protección de datos (DPD)?',
                helpText: '',
                validations: '',
                context: '',
            },
            third_parties_entries_modal_title: {
                question: 'Añadir proveedor',
            },
            dpd_modal_title: {
                question: 'Añadir delegado de protección de datos',
            },
            dpd_name_label: {
                question: 'Nombre / Razón social',
            },
            dpd_email_label: {
                question: 'Email',
            },
            dpd_phone_label: {
                question: 'Teléfono',
            },
            dpd_signed_label: {
                question: '¿Ha firmado el nombramiento correspondiente?',
            },
            dpd_notified_label: {
                question: '¿Habéis comunicado el nombramiento de DPD ante la Autoridad de Control correspondiente?',
            },
            web_presence: {
                question: '¿Tenéis sitio web?',
            },
            web_modal_title: {
                question: 'Añadir sitio web',
            },
            website_url_label: {
                question: 'Dirección / Url',
            },
            website_services_label: {
                question: '¿Ofrecéis algunas de estas opciones en la web?',
            },
            requires_registration_label: {
                question: '¿Es necesario registrarse para proceder con la compra?',
            },
            ti_informacion_tratamientorecdatos: {
                question: 'Cuando recopiláis datos, ¿explicáis adecuadamente a la persona interesada cómo se van a gestionar sus datos?',
                helpText: '',
                validations: '',
                context: '',
            },
            information_types: {
                question: '¿Qué información proporcionáis?',
                helpText: '',
                validations: '',
                context: '',
            },
            solicitud_derechos: {
                question: '¿Habéis recibido alguna solicitud de ejercicio de derechos en los últimos 6 meses?',
                helpText: '',
                validations: '',
                context: '',
            },
            der_ejercitadosprocedimiento: {
                question: '¿Disponéis de un procedimiento de atención de los derechos?',
            },
            emailpdd: {
                question: '¿Qué dirección de email queréis utilizar para la documentación de la gestión de Protección de Datos?',
            },
            st_incidenteseguridad: {
                question: '¿Habéis tenido algún incidente de seguridad de la información en los últimos 6 meses?',
            },
            sanciones_types: {
                question: '¿Sabéis si habéis recibido alguna sanción o incumplido alguna de estas normativas?',
            },
            ms_limitaccesofisiconoaut: {
                question: '¿Existe un control de acceso físico a las instalaciones de la empresa?',
            },
            ms_portfueraemp: {
                question: '¿Utilizáis dispositivos portátiles?',
            },
            trabajodistancia: {
                question: '¿Ofrecéis la posibilidad de teletrabajar o trabajar a distancia a las personas trabajadoras?',
            },
            ms_cs: {
                question: '¿Tenéis copias de seguridad de los sistemas de información?',
            },
            politica_procedimiento_types: {
                question: '¿Cuál de las siguientes políticas y/o procedimientos disponéis?',
            },
            ps_cps_evidenciaadecuado: {
                question: '¿Disponéis de una operativa para garantizar que vuestros proveedores de servicios con acceso a datos cumplen con la normativa de Protección de datos?',
            },
            empleadoscomunicacionpolpro: {
                question: '¿Se les ha comunicado al personal las políticas y procedimientos de seguridad de la información?',
            },
            empleadoscompromisoconf: {
                question: '¿Las personas trabajadoras han firmado un compromiso de confidencialidad?',
            },
            servctrlhorario_types: {
                question: 'Indica qué sistema de control horario utilizáis:',
            },
            ch_infomeca: {
                question: '¿Habéis informado a las personas trabajadoras sobre la existencia de estas herramientas de control horario?',
            },
            ch_conservacion: {
                question: '¿Conserváis los registros por un periodo mínimo de 4 años?',
            },
            ch_garanomanip: {
                question: '¿Existen garantías de que los registros generados por el sistema de control horario no son manipulables por personal no autorizado?',
            },
            ch_accesoreg: {
                question: '¿Pueden las personas trabajadoras, representantes o Inspección de Trabajo y Seguridad Social acceder a estos registros de horario?',
            },
            empherramientascontrolemp_types: {
                question: '¿Qué herramientas de vigilancia y control utilizáis?',
            },
            ce_informa: {
                question: '¿Habéis informado a las personas trabajadoras sobre la existencia de estas herramientas?',
            },
            imparteformacionesempleados_types: {
                question: 'Selecciona las materias en las que habéis realizado formaciones',
            },
            pp_procedimientosegformacion: {
                question: '¿Disponéis de un procedimiento de formación para los empleados en materia de cumplimiento normativo?',
            },
            third_parties_entries: {
                question: '¿Tenéis proveedores? Si es así, añade tantos proveedores como tengas, si no trabajas con proveedores continúa sin añadir ninguno. Si no tienes todos los datos, no te preocupes podrás añadirlos más adelante.',
            },
            CONVERSIA_Actividad_label: {
                question: 'Actividad:',
            },
            ps_accesodatos_label: {
                question: '¿Este proveedor tiene acceso a datos?:',
            },
            CONVERSIA_RazonSocial_label: {
                question: 'Razón social:',
            },
            CONVERSIA_CIF_label: {
                question: 'NIF:',
            },
            CONVERSIA_Direccion_label: {
                question: 'Dirección:',
            },
            CONVERSIA_CP_label: {
                question: 'Código postal:',
            },
            CONVERSIA_Poblacion_label: {
                question: 'Población:',
            },
            CONVERSIA_Provincia_label: {
                question: 'Provincia:',
            },
            CONVERSIA_PersonaContacto_label: {
                question: 'Persona de contacto:',
            },
            CONVERSIA_Telefono_label: {
                question: 'Teléfono:',
            },
            CONVERSIA_Email_label: {
                question: 'E-mail:',
            },
            pp_procedimientoseg: {
                question: '¿Disponéis de directrices, políticas y/o procedimientos para la gestión de la seguridad de la información?',
            },
            cig_pt_informatizados_c: {
                question: '¿Disponéis de algún ordenador, sistema de pago electrónico (TPV), dirección de email, dispositivos móviles o cualquier tipo de sistema informático donde se almacene información?',
            },
            cig_mensajeriainstantanea_c: {
                question: '¿Utilizáis alguna herramienta de mensajería instantánea con el personal y/o con terceros?',
            },
            cig_envpromopubli_c: {
                question: '¿Realizáis comunicaciones publicitarias y/o envíos promocionales?',
            },
            cig_rp_nombramiento_c: {
                question: '¿Ha firmado el nombramiento correspondiente?',
            },
            cig_actuprevcumplinorm_c: {
                question: '¿Habéis llevado a cabo acciones previas para cumplir con la normativa de protección de datos?',
            },
            cig_actuacionespdd_c: {
                question: '¿Habéis llevado a cabo acciones previas para cumplir con la normativa de protección de datos?',
            },
            cig_registroactivtrat_c: {
                question: '¿Disponéis de un registro de actividades de tratamiento?',
            },
            cig_registroactivtrat_act_c: {
                question: '¿Se mantiene actualizado?',
            },
            cig_pt_existeeipd_c: {
                question: '¿Habéis analizado de manera profunda los tratamientos de datos que puedan suponer un alto riesgo (realización de una Evaluación de Impacto)?',
            },
            cig_audi_sometido_c: {
                question: '¿Habéis pasado alguna auditoría en los últimos dos años?',
            },
            cig_ds_auditext_c: {
                question: '¿Habéis realizado auditorías en materia de PDD?',
            },
            cig_st_registro_c: {
                question: '¿Se ha registrado este incidente?',
                context: 'Durante el formulario nos indicásteis que habiais tenido algún incidente de seguridad de la información en los últimos 6 meses.',
            },
            cig_reqorgcont_c: {
                question: '¿Habéis recibido algún requerimiento de algún organismo de control en los últimos 6 meses?',
            },
            cig_sanciones_normativa_c: {
                question: '¿Sabéis si habéis recibido alguna sanción o incumplido alguna normativa?',
            },
            cig_f_imparteformacionesempleados_c: {
                question: '¿Impartís formación al personal de la empresa en materia de teletrabajo o protección de datos?',
            },
            cig_ms_au_c: {
                question: '¿Los usuarios acceden a los sistemas con contraseña, tarjeta magnética, por huella dactilar o algún mecanismo de autenticación unipersonal?',
            },
            cig_ms_limitacionusuariosnoaut_c: {
                question: '¿Tenéis una relación actualizada de las personas con accesos al sistema informático?',
            },
            cig_ms_portfueraemprelacion_c: {
                question: '¿Tenéis una relación actualizada de estos dispositivos?',
                context: 'Durante el formulario nos indicáteis que utilizáis dispositivos portátiles',
            },
            cig_ms_portautorizado_c: {
                question: '¿El personal tiene permiso para almacenar información en el disco duro del portátil?',
            },
            has_conservation_paper_document: {
                question: '¿Tenéis establecido un modo de conservación para la documentación en papel?',
            },
            delete_information_mechanism: {
                question: '¿Tenéis mecanismos para eliminar la información tanto en soporte papel como en soportes informáticos (memoria USB, Discos duros, CD...)?',
            },
            cig_tc_emptestpsicotecpers_c: {
                question: 'Durante los procesos de selección, ¿se les realizan tests psicotécnicos o de personalidad a las personas candidatas?',
            },
            cig_et_empleadoscomunicado_c: {
                question: '¿Habéis informado a todo el personal sobre sus funciones y obligaciones mediante un comunicado interno?',
            },
            cweb_newsletter_c: {
                question: '¿Envíais alguna newsletter o boletín informativo desde el sitio web?',
            },
            ot_s1_q1: {
                question: '¿Cómo recogéis la información?',
            },
            ot_s1_q2: {
                question: '¿De dónde provienen los datos?',
            },
            ot_s1_q3: {
                question: '¿Cómo los verificáis?',
            },
            ot_s1_q4: {
                question: '¿Qué figuras intervienen en la recogida de datos?',
            },
            ot_s1_q5: {
                question: '¿Qué activos intervienen en este proceso?',
            },
            ot_s2_q1: {
                question: '¿En qué tipo de soporte informático almacenáis la información?',
            },
            ot_s2_q2: {
                question: '¿Habéis establecido un modo de conservación de la documentación en papel?',
            },
            ot_s2_q3: {
                question: '¿En qué soporte?',
            },
            ot_s2_q4: {
                question: '¿Cómo los conserváis?',
            },
            ot_s2_q5: {
                question: '¿En qué sitio los almacenáis?',
            },
            ot_s2_q6: {
                question: '¿Dónde se encuentran los datos?',
            },
            ot_s2_q7: {
                question: '¿Qué figuras intervienen en la clasificación y almacenamiento de los datos?',
            },
            ot_s3_q1: {
                question: '¿Qué tipo de soporte informático utilizáis?',
            },
            ot_s3_q2: {
                question: '¿Y de tipo no informático?',
            },
            ot_s3_q3: {
                question: '¿Qué mecanismos de autenticación e identificación utilizáis para el acceso?',
            },
            ot_s3_q4: {
                question: '¿Qué figuras intervienen en el uso, acceso y explotación de los datos?',
            },
            ot_s4_q1: {
                question: '¿Qué mecanismos de destrucción de documentación y datos utilizáis?',
            },
            ot_s4_q2: {
                question: '¿Qué figuras intervienen en la destrucción de datos?',
            },
            ms_soporte_types: {
                question: '¿En que soporte conserváis la documentación en papel?',
            },
            ms_modo_types: {
                question: '¿Cómo conserváis la documentación en papel?',
            },
            ms_ubi_types: {
                question: '¿Dónde conserváis la documentación en papel?',
            },
        },
        answers: {
            postal_mail: 'Correo postal',
            email: 'Email',
            social_media: 'Redes sociales',
            instant_messaging: 'Mensajería instantánea (SMS, WhatsApp, etc)',
            phone_calls: 'Llamadas telefónicas',
            no_publicity: 'No realizo ningún tipo de comunicación publicitaria.',
            yes_surveillance: 'Sí',
            no_surveillance: 'No',
            special_category: 'Datos de categoría especial',
            minors_data: 'Datos de menores',
            vulnerable_subjects: 'Datos sujetos vulnerables',
            international_transfers: 'Transferencias internacionales de datos',
            none_of_above: 'Ninguno de los anteriores',
            cweb_none: '-',
            yes_signed: 'Sí',
            no_signed: 'No',
            yes_notified: 'Sí',
            no_notified: 'No',
            add_dpd: 'AÑADIR DELEGADO DE PROTECCIÓN DE DATOS',
            add_web: 'AÑADIR SITIO WEB',
            add_thridparty: 'AÑADIR PROVEEDOR',
            cweb_ventaproductos_c: 'Venta de productos',
            cweb_ventaservicios_c: 'Adquisición de servicios',
            cweb_ventareservas_c: 'Gestión de reservas',
            web_table_headers_url: 'Dirección/Url',
            web_table_headers_services: 'Servicios ofrecidos',
            web_table_headers_registration: 'Registro',
            web_table_headers_newsletter: 'Envío publicidad',
            thirdparty_table_headers_razonsocial: 'Razón social',
            thirdparty_table_headers_nif: 'NIF',
            thirdparty_table_headers_activity: 'Actividad',
            thirdparty_table_headers_personaContacto: 'P. de contacto',
            thirdparty_table_headers_personaContacto_tooltip: 'Persona de contacto',
            thirdparty_table_headers_phone: 'Teléfono',
            clinformativas: 'Datos de contacto del responsable',
            informaciondpd: 'Datos de contacto del DPD',
            infofinalidades: 'Finalidades con las que se van a tratar los datos personales',
            clinformativas_bj: 'Base jurídica',
            clinformativas_pc: 'Plazo de conservación de los datos',
            informacesionesdatos_c: 'Información sobre posibles cesiones de datos',
            derechosafectados_c: 'Derechos de las personas interesadas',
            derechoreclamacion_c: 'Derecho a presentar una reclamación ante una autoridad de control',
            informatransfinteresado_c: 'Información relativa a la transferencia internacional de los datos',
            sanciones_rgpdlssi: 'Protección de datos',
            sanciones_lssi: 'Ley de servicios de sociedad de la información',
            sanciones_prp: 'Prevención de riesgos penales',
            sanciones_rh: 'Control horario',
            sanciones_prl: 'Prevención de riesgos laborales',
            sanciones_pbc: 'Prevención de blanqueo de capitales',
            sanciones_pigd: 'Planes de igualdad',
            sanciones_cd: 'Canal de Denuncias',
            pp_politicaseguridadfisica: ' Política respecto a la seguridad física de la empresa',
            pp_seguridadinformat: 'Políticas y/o procedimientos de seguridad informática',
            pp_equiposinformaticos: 'Políticas y/o procedimientos sobre equipos informáticos',
            pp_relacionterceros: 'Procedimiento, política y/o acuerdo respecto a las relaciones con terceras partes',
            pp_violacionseguridad: 'Procedimiento o política en caso de respuesta de incidentes/violaciones de seguridad de la información',
            ch_mec_manual: 'Sistema manual',
            ch_mec_tacceso: 'Tarjeta de acceso',
            ch_mec_biometria: 'Biometría (huella dactilar, retina, reconocimiento facial)',
            ch_mec_geo: 'Geolocalización',
            ch_mec_apps: 'Aplicación móvil (smartphone)',
            ch_mec_login: 'LOG-IN(presencia a través del equipo del usuario)',
            ce_geo: 'Geolocalización',
            ce_video: 'Videovigilancia',
            ce_app: 'Aplicación instalada en las herramientas laborales',
            formacionpdd: 'Protección de datos',
            formacionteletrabajo: 'Teletrabajo',
            formacionlssi: 'Ley de servicios de sociedad de la información',
            formacionprp: 'Prevención de riesgos penales',
            formacionprl: 'Prevención de riesgos laborales',
            formacionpbc: 'Prevención de blanqueo de capitales',
            formacionpigd: 'Planes de igualdad',
            formacioncd: 'Canal de Denuncias',
            cig_ms_soportearchi_c: 'En archivadores',
            cig_ms_soportecarpetas_c: 'En carpetas',
            cig_ms_soportesin_c: 'Sin soporte',
            cig_ms_modoinvbajollave_c: 'Inventariada bajo llave',
            cig_ms_modoinvsinllave_c: 'Inventariada sin llave',
            cig_ms_modosininvllave_c: 'Sin inventariar bajo llave',
            cig_ms_modosininvsinllave_c: 'Sin inventariar sin llave',
            cig_ms_ubibandejas_c: 'En bandejas',
            cig_ms_ubicajones_c: 'En cajones',
            cig_ms_ubicajasarchiv_c: 'En cajas de archivo',
            cig_ms_ubiarmario_c: 'En armarios',
            cig_ms_conservaciondocpapel_c: 'No tenemos un modo establecido',
            cig_ms_destrucpapelera_c: 'Con papelera',
            cig_ms_destrucdestruc_c: 'Con destructora de papel',
            cig_ms_destrucequipos_c: 'Con equipos de destrucción de soportes informáticos',
            cig_ms_mecanismodestruccion_c: 'No disponemos de equipos para eliminar la información',
            procent_forweb_c_literal: 'Formulario web',
            procent_forpapel_c_literal: 'Formulario papel',
            procent_ent_c_literal: 'Entrevista',
            procent_web_c_literal: 'Encuesta web',
            procent_papel_c_literal: 'Encuesta papel',
            procent_tel_c_literal: 'Llamada telefónica',
            procent_herr_c_literal: 'Herramientas de análisis digital',
            procent_otros_c_literal: 'Otros mecanismos de recogida',
            procent_int_c_literal: 'Interesado',
            procent_ter_c_literal: 'Terceros',
            procent_publico_c_literal: 'Fuentes de acceso público',
            procent_origen_c_literal: 'Otro origen',
            procent_dni_c_literal: 'Comprobación a través de DNI',
            procent_uscont_c_literal: 'Usuario y Contraseña',
            procent_digi_c_literal: 'Certificado Digital',
            procent_correo_c_literal: 'Enlace a través de correo electrónico',
            procent_tarjint_c_literal: 'Tarjeta inteligente (smartcard)',
            procent_acc_c_literal: 'Código de acceso',
            procent_bio_c_literal: 'Factores biométricos',
            procent_verificaotros_c_literal: 'Otro proceso de verificación',
            procent_ningun_c_literal: 'Ninguno',
            procent_figuraint_c_literal: 'Interesado',
            procent_figuraresp_c_literal: 'Responsable',
            procent_figurausint_c_literal: 'Usuario del sistema interno',
            procent_figurausext_c_literal: 'Usuario del sistema externo',
            procent_figuradpd_c_literal: 'Delegado de protección de datos',
            procent_figuraco_c_literal: 'Responsable de Privacidad',
            procent_figuraprov_c_literal: 'Proveedor',
            procent_figuraotros_c_literal: 'Otras figuras',
            procalma_cpd_c_literal: 'Centro de procesamiento de datos',
            procalma_usb_c_literal: 'Memoria USB',
            procalma_tarjmem_c_literal: 'Tarjeta de memoria',
            procalma_nube_c_literal: 'Nube',
            procalma_disduro_c_literal: 'Discos duros',
            procalma_cdrdvd_c_literal: 'CD-ROM/DVD-ROM',
            procalma_soportearchi_c_literal: 'Archivadores',
            procalma_soportecarpetas_c_literal: 'Carpetas',
            procalma_soportesin_c_literal: 'Sin soporte',
            procalma_modoinvbajollave_c_literal: 'Inventariada bajo llave',
            procalma_modoinvsinllave_c_literal: 'Inventariada sin llave',
            procalma_modosininvllave_c_literal: 'Sin inventariar bajo llave',
            procalma_modosininvsinllave_c_literal: 'Sin inventariar sin llave',
            procalma_ubibandejas_c_literal: 'Bandejas',
            procalma_ubicajones_c_literal: 'Cajones',
            procalma_ubicajasarchivo_c_literal: 'Cajas de archivo',
            procalma_ubiarmario_c_literal: 'Armario',
            procalma_ubiotros_c_literal: 'Otra ubicación',
            procalma_esp_c_literal: 'España',
            procalma_ue_c_literal: 'Unión Europea',
            proclama_otrospais_c_literal: 'Otros países',
            procalma_figuraint_c_literal: 'Interesados',
            procalma_figuraresp_c_literal: 'Responsable',
            procalma_figurausint_c_literal: 'Usuario del sistema interno',
            procalma_figurausext_c_literal: 'Usuario del sistema externo',
            procalma_figuradpd_c_literal: 'Delegado de protección de datos',
            procalma_figuraco_c_literal: 'Responsable de Privacidad',
            procalma_figuraprov_c_literal: 'Proveedor',
            procalma_figuraotros_c_literal: 'Otras figuras',
            procuso_proginf_c_literal: 'Programas informáticos',
            procuso_soft_c_literal: 'Software personalizado',
            procuso_app_c_literal: 'App personalizada',
            procuso_hoja_c_literal: 'Hoja de datos en papel',
            procuso_form_c_literal: 'Formularios en papel',
            procuso_dni_c_literal: 'Comprobación a través de DNI',
            procuso_uscon_c_literal: 'Usuario y Contraseña',
            procuso_certdigi_c_literal: 'Certificado Digital',
            procuso_enlace_c_literal: 'Enlace a través de correo electrónico',
            procuso_smartcard_c_literal: 'Tarjeta inteligente (smartcard)',
            procuso_codacc_c_literal: 'Código de acceso',
            procuso_facbio_c_literal: 'Factores biométricos',
            procuso_otros_c_literal: 'Otros mecanismos de autenticación',
            procuso_ninguno_c_literal: 'Ninguno',
            procuso_figuraint_c_literal: 'Interesado',
            procuso_figuraresp_c_literal: 'Responsable',
            procuso_figurausint_c_literal: 'Usuario del sistema interno',
            procuso_figurausext_c_literal: 'Usuario del sistema externo',
            procuso_figuradpd_c_literal: 'Delegado de protección de datos',
            procuso_figuraco_c_literal: 'Responsable de Privacidad',
            procuso_figuraprov_c_literal: 'Proveedor',
            procuso_figuraotros_c_literal: 'Otras figuras',
            procdest_destrucpapelera_c_literal: 'Papelera',
            procdest_destrucdestruc_c_literal: 'Destructora de papel',
            procdest_destrucequipos_c_literal: 'Equipos de destrucción de soportes informáticos',
            procdest_figuraint_c_literal: 'Interesado',
            procdest_figuraresp_c_literal: 'Responsable',
            procdest_figurausint_c_literal: 'Usuario del sistema interno',
            procdest_figurausext_c_literal: 'Usuario del sistema externo',
            procdest_figuradpd_c_literal: 'Delegado de protección de datos',
            procdest_figuraco_c_literal: 'Responsable de Privacidad',
            procdest_figuraprov_c_literal: 'Proveedor',
            procdest_figuraotros_c_literal: 'Otras figuras',
        },
        validationMessages: {
            exclusivity_rule: "No puedes seleccionar 'Ninguno de los anteriores' junto con otras opciones",
            required_field: 'Este campo es obligatorio',
            invalid_number: 'Por favor, introduzca un número válido entre {min} y {max}',
        },
        subSections: {
            address_third_parties: {
                name: 'Dirección del proveedor',
            },
            contact_third_parties: {
                name: 'Persona de contacto',
            },
            type_third_parties: {
                name: 'Tipo de proveedor',
            },
            aditional_info_third_parties: {
                name: 'Información adicional',
            },
        },
    },
    en: {},
    ca: {},
    eu: {},
    gl: {},
};
